import { Component, OnInit } from '@angular/core';

import { parseString } from 'xml2js';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {ReportDataService} from '../report-data.service';
import {Report} from '../shared/report.model';
import {StartWizardModalComponent} from '../start-wizard-modal/start-wizard-modal.component';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.css']
})
export class IntroComponent implements OnInit {

  report: Report;
  startWizardModal: BsModalRef;
  constructor(private modalService: BsModalService, private reportService: ReportDataService, private toastr: ToastrService) { }

  ngOnInit() {
    this.report = this.reportService.getReport();
  }

  launchStartWizard() {
    this.startWizardModal = this.modalService.show(StartWizardModalComponent, {class: 'modal-lg', keyboard: false, ignoreBackdropClick: true});
  }
}



// WEBPACK FOOTER //
// ./src/app/intro/intro.component.ts